'use client';

import Image from 'next/image';
import { useState } from 'react';

interface NotificationBarProps {
  iconUrl: string;
  label: string;
  onClick?: () => void;
}

export default function NotificationBar({ iconUrl, label, onClick }: NotificationBarProps) {
  const [isVisible, setIsVisible] = useState(true);

  const handleClickCloseButton = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      onClick={onClick}
      className="flex w-full cursor-pointer items-center gap-4 bg-noticebar-bg px-3 py-2"
    >
      <div className="flex w-full items-center gap-2">
        <Image src={iconUrl} alt="Notification Icon" width={28} height={28} />
        <span className="typo-body-5 text-g-00">{label}</span>
      </div>

      <div onClick={handleClickCloseButton} className="cursor-pointer">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M3.33301 3.33203L7.99967 7.9987L12.6663 12.6654"
            stroke="var(--color-g-00)"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
          <path
            d="M12.667 3.33203L8.00033 7.9987L3.33366 12.6654"
            stroke="var(--color-g-00)"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
}
